<template>
  <div
    class="koc-view koc-purchase-course-view"
    data-observe-resize
    data-observe-theme
  >
    <div class="koc-wrapper-component">
      <main>
        <div class="koc-panel-component">
          <header>
            <section class="koc-header-with-icon">
              <div class="koc-header-icon-container">
                <font-awesome-icon
                  :icon="['fa', 'money-check-dollar']"
                  class="koc-header-icon"
                />
              </div>
              <div class="koc-montserrat koc-heavy-text">
                Checkout
              </div>
            </section>
          </header>

          <section
            v-if="1 !== products.options.length"
            class="koc-section"
          >
            <purchase-product-select-component
              :options="products.options"
              :selected="state.selected"
              @next="next"
              @product-change="updateProduct"
            />
          </section>
          <section
            v-else
            class="mb32"
          />

          <section class="koc-section">
            <purchase-summary-component
              v-if="state.preview"
              :options="products.options"
              :preview="state.preview"
            />
            <purchase-coupon-component
              :coupon="state.coupon"
              @validate="updateCoupon"
            />
          </section>

          <section
            v-if="!state.user"
            class="koc-section"
          >
            <auth-login-register-component
              @login="login"
              @register="register"
            />
          </section>

          <section
            v-if="state.user"
            class="koc-section"
          >
            <payment-billing-details-component
              :default-profile="state.defaultProfile"
              :profiles="state.profiles"
              :selected-profile="state.selectedProfile"
              @activate="activatePayment"
              @create="createPayment"
              @remove="removePayment"
              @update="updatePayment"
            />
          </section>

          <section class="koc-section">
            <footer>
              <section class="koc-section">
                <footer>
                  <section class="koc-footer">
                    <div class="koc-full">
                      <p
                        v-if="missingFields()"
                        class="koc-warning koc-row float-right"
                      >
                        {{ missingFields() }}
                      </p>
                    </div>
                    <div class="koc-full koc-flex-center koc-row right koc-flex-wrap">
                      <div class="">
                        <label
                          for="terms"
                          class="koc-option koc-terms float-right"
                        >
                          <div class="koc-check">
                            <input
                              id="terms"
                              v-model="state.terms"
                              type="checkbox"
                              name="terms"
                            >
                            <div class="koc-box" />
                          </div>
                          I have read and accept the
                          <a
                            :href="termsUrl"
                            target="_blank"
                          >
                            TERMS &amp; CONDITIONS
                          </a>
                        </label>
                      </div>
                      <div class="koc-accept-submit">
                        <div class="">
                          <div class="koc-submit">
                            <button
                              class="koc-button koc-ripple"
                              :disabled="!state.canSubmit"
                              @click="purchase"
                            >
                              CONFIRM PAYMENT
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </footer>
                <main
                  v-if="state.hasDisclaimer"
                >
                  <div class="koc-full float-right">
                    <p
                      class="koc-checkout-disclaimer"
                      v-html="state.preview.next.disclaimer.text"
                    />
                  </div>
                </main>
              </section>
            </footer>
          </section>
          <div
            v-if="state.showNotification"
            class="koc-notification koc-full"
          >
            <h3>{{ state.notification }}</h3>
            <div
              class="koc-close"
              @click="clearNotification"
            />
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script src="./course.js"></script>
<style lang="scss" scoped src="./course.scss"></style>
